import { gql } from '@apollo/client'
import { SelfReflectionQuestionsFragment } from './fragments/SelfReflectionQuestionsFragment'

export const SelfReflectionQuestions = gql`
  query selfreflectionQuestions($employeeId: HashedId!, $meetingId: HashedId!) {
    selfreflectionQuestions(employeeId: $employeeId, meetingId: $meetingId) {
      ...SelfReflectionQuestion
    }
  }
  ${SelfReflectionQuestionsFragment}
`

export default {
  SelfReflectionQuestions,
}
